import { amenitiesValidation } from '../constructionStatus/amenities/amenities.validation';
import { sourceValidation } from '../constructionStatus/source/source.validation';
import { tagValidation } from '../constructionStatus/tags/tag.validation';


export const commonValidation = {
  amenities: amenitiesValidation,
  tags: tagValidation,
  source: sourceValidation,
};
